import { Grid, Stack } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionNOTESFields } from '../types/fields';
import { OperacionNOTES } from "../types/types";

type SeccionNOTESDatosSeccionesProps = {
  operacion?: OperacionNOTES;
}

const SeccionNOTESDatosSecciones = ({ operacion }: SeccionNOTESDatosSeccionesProps) => {
  if (!operacion) return null;

  return (
    <Stack gap={3}>
      <CardActions title='Sección - Información General' icon='mdi:information-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={3}>
            <FieldView label='Tipo de Nota' value={operacion[OperacionNOTESFields.TipoNota]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Cliente' value={operacion[OperacionNOTESFields.Cliente]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Capital a suscribir' value={operacion[OperacionNOTESFields.CapitalASuscribir]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Moneda' value={operacion[OperacionNOTESFields.Moneda]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Vencimiento' value={dateFormatter.toShortDate(operacion[OperacionNOTESFields.Vencimiento])} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Fecha de Emisión' value={dateFormatter.toShortDate(operacion[OperacionNOTESFields.FechaEmision])} />
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldView label='Emisor' value={operacion[OperacionNOTESFields.Emisor]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Sub-yacentes' icon='mdi:chart-scatter-plot' colapsable>
        <SectionBox>
          <Grid item xs={12}>
            <FieldView label='Subyacentes' value={operacion[OperacionNOTESFields.Subyacentes]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsSubyacentes]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Cupón' icon='mdi:percent' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <FieldView label='Cupón' value={operacion[OperacionNOTESFields.Cupon]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Frecuencia de pago' value={operacion[OperacionNOTESFields.FrecuenciaPago]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Condición de pago' value={operacion[OperacionNOTESFields.CondicionPago]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsCupon]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Participación' icon='mdi:account-group-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <FieldView label='Participación' value={operacion[OperacionNOTESFields.Participacion]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Forma de participación' value={operacion[OperacionNOTESFields.FormaParticipacion]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Descripción de la participación' value={operacion[OperacionNOTESFields.DescripcionParticipacion]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsParticipacion]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Protección de Capital' icon='mdi:shield-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <FieldView label='Tipo de protección' value={operacion[OperacionNOTESFields.TipoProteccion]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Nivel de protección' value={operacion[OperacionNOTESFields.NivelProteccion]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Descripción de la protección' value={operacion[OperacionNOTESFields.DescripcionProteccion]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsProteccion]} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Rescate Anticipado' icon='mdi:calendar-remove-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <FieldView label='Barrera de rescate anticipado' value={operacion[OperacionNOTESFields.BarreraRescateAnticipado]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Condición de rescate anticipado' value={operacion[OperacionNOTESFields.CondicionRescateAnticipado]} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldView label='Frecuencia de observación' value={operacion[OperacionNOTESFields.FrecuenciaObservacion]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones adicionales' value={operacion[OperacionNOTESFields.ObsRescateAnticipado]} />
          </Grid>
        </SectionBox>
      </CardActions>
    </Stack>
  );
}

export default SeccionNOTESDatosSecciones;
